// helper method to generate the learn more content for Workday
const getWorkdayLearnMoreContent = () => {
  const lines = [
    `<b>Push WorkBoard Personal OKRs to Workday as Goals</b> and Milestones that are updated daily in Workday.`,
    `<b>Sync over Workday Goals as Personal OKRs in WorkBoard</b> so they appear in side by side team OKRs in WorkBoard for team members; updated daily from changes made in Workday.`,
    `<b>Push conversation records from WorkBoard Check-ins to Workday</b> as worker documents for record keeping in Workday.`,
  ];
  const html = '';
  lines.forEach((l) => {
    html += `<div>${l}</div><br />`;
  });
  return html;
};

// map is kpi microservice app name => wobo external app name
export const kpiMarketplaceConstants = {
  KPI_MARKET_PLACE_CUSTOM_APP_ID: [17, 18, 19, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 36, 38, 39, 40, 41, 42, 44],

  KPI_MARKET_PLACE_CUSTOM_APP_SOURCE_LINK: [17, 18, 19, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 36, 38, 39, 40, 41, 42, 44],

  DUPLICATE_INTEGRATION_IDENTITY_FOUND_COOKIE: 'duplicateIntegrationIdentityFound',

  LEGACY_CLASSNAMES_MAP: new Map([
    ['slack', '.slack-integration-button'],
    ['ms_graph', '.ms-team-integration-button'],
    ['cisco_webex', '.webx-integration-button'],
    ['google', '.google-integrate'],
    ['outlook', '.outlook-integrate'],
    ['ms_planner', '.ms-planner-integration-button'],
    ['azure_cloud', '.ado-integration-btn'],
    ['jira', '.jira-oauth-click'],
    ['workday', '.workday-auth-click'],
    ['asana', '.asana-integration-button'],
    ['wobo_kpi', '.wobo-kpi-integration-button'],
  ]),

  WOBO_EXT_APP_ID_MAP: new Map([
    ['salesforce', 17],
    ['rally', 18],
    ['powerbi', 19],
    ['smartsheet', 21],
    ['tableau', 22],
    ['excel365', 23],
    ['snowflake', 24],
    ['gsheet', 25],
    ['trello', 26],
    ['greenhouse', 27],
    ['jira', 28], // new jira.
    ['gitlab', 29],
    ['asana', 30],
    ['workday', 36],
    ['hubspot', 38],
    ['monday', 39],
    ['wobo_kpi', 40],
    ['azure-devops', 41],
    ['ms-planner', 42],
    ['wrike', 44],
  ]),

  WOBO_EXT_APP_KPI_TYPE_MAP: new Map([
    [1, 'Slack'],
    [5, 'jira'],
    [6, 'asa'],
    [9, 'ms_graph'],
    [11, 'ms'],
    [13, 'ado'],
    [17, 'salesforce'],
    [18, 'rally'],
    [19, 'powerbi'],
    [21, 'smartsheet'],
    [22, 'tableau'],
    [23, 'excel365'],
    [24, 'snowflake'],
    [25, 'gsheet'],
    [26, 'trello'],
    [27, 'greenhouse'],
    [28, 'jira_kpi'],
    [29, 'gitlab'],
    [30, 'asana_kpi'],
    [36, 'workday_kpi'],
    [38, 'hubspot'],
    [39, 'monday_kpi'],
    [40, 'wobo_kpi'],
    [41, 'azure-devops'],
    [42, 'ms-planner'],
    [44, 'wrike'],
  ]),

  WOBO_EXT_APP_DISPLAY_NAME_MAP: new Map([
    [1, 'Slack'],
    [2, 'Google Calendar'],
    [3, 'Microsoft Outlook'],
    [5, 'Jira'],
    [6, 'Asana'],
    [9, 'Microsoft Teams'],
    [11, 'Ms Planner'],
    [13, 'Azure DevOps'],
    [16, 'Webex'],
    [17, 'Salesforce'],
    [18, 'Rally'],
    [19, 'Power BI'],
    [21, 'Smartsheet'],
    [22, 'Tableau'],
    [23, 'Excel'],
    [24, 'Snowflake'],
    [25, 'Gsheet'],
    [26, 'Trello'],
    [27, 'Greenhouse'],
    [28, 'Jira'], // new jira.
    [29, 'Gitlab'],
    [30, 'Asana'],
    [36, 'Workday'],
    [38, 'Hubspot'],
    [39, 'Monday'],
    [40, 'KPI'],
    [41, 'Azure Devops'],
    [42, 'Microsoft Planner'],
    [44, 'Wrike'],
  ]),

  WOBO_EXT_APP_DESCRIPTION_MAP: new Map([
    [1, 'Invite teammates, add comments, and more through Slack'],
    [2, 'Sync your Google Calendar with WorkBoard Meetings'],
    [3, 'Sync your Outlook with WorkBoard Meetings'],
    [9, 'Invite teammates, add comments, and more through Microsoft Teams'],
    [16, 'Invite teammates, add comments, and more through Webex Teams'],
    [36, 'Sync WorkBoard Personal OKRs seamlessly with Workday Goals, and more'],
  ]),

  WOBO_EXT_APP_LOGO_MAP: new Map([
    [1, 'icon icon-slack-logo-40px'],
    [2, 'icon icon-gcalendar-logo-40px'],
    [3, 'icon icon-outlook-logo-40px'],
    [5, 'JiraKpiIcon'],
    [6, 'icon icon-Asana_logo-24px'],
    [9, 'icon icon-msteams-logo-40px'],
    [11, 'MSPlannerIcon'],
    [13, 'icon icon-azure_devops'],
    [16, 'icon icon-wteams-logo-40px'],
    [17, 'SalesforceIcon'],
    [18, 'RallyIcon'],
    [19, 'PowerBIIcon'],
    [21, 'icon icon-smartsheet-logo-14px'],
    [22, 'TableauIcon'],
    [23, 'ExcelIcon'],
    [24, 'SnowflakeIcon'],
    [25, 'GsheetIcon'],
    [26, 'TrelloIcon'],
    [27, 'GreenhouseIcon'],
    [28, 'JiraKpiIcon'],
    [29, 'GitlabIcon'],
    [30, 'AsanaKpiIcon'],
    [36, 'WorkdayKpiIcon'],
    [38, 'HubspotIcon'],
    [39, 'MondayKpiIcon'],
    [40, 'icon-kpi-pulse-bluegreen-24px'],
    [41, 'AzureDevOpsKpiIcon'],
    [42, 'MSPlannerIconKpi'],
    [44, 'WrikeKpiIcon'],
  ]),

  WOBO_EXT_APP_DUPLICATE_INTEGRATION_FOUND_MAP: new Map([
    [
      'ms_graph',
      `
        <h3 class="kpis-content-sub-heading">Duplicate MS Teams identity found</h3>
        The MS Teams user you are integrating is already registered with another WorkBoard user.
        <br />
        <br />
        Please disable the integration from the other WorkBoard user before continuing.
    `,
    ],
    [
      'Slack',
      `
        <h3 class="kpis-content-sub-heading">Duplicate Slack identity found</h3>
        The Slack identity you are integrating is already registered with another WorkBoard user.
        <br />
        <br />
        Please disable the integration from the other WorkBoard user before continuing.
    `,
    ],
  ]),

  WOBO_EXT_APP_LEARNMORE_CONTENT_MAP: new Map([
    [
      'ms_graph',
      `
        <h3 class="kpis-content-sub-heading">Monitor OKR progress without switching tools</h3>
        Bring your OKRs, Heatmap, automated Biz Reviews, and Results Analytics right into your Microsoft Teams environment for seamless access to the facts you need every day.
        <br />
        <br />
        <h3 class="kpis-content-sub-heading">Calibrate OKRs on Mondays and Celebrate victories on Fridays</h3>
        Team leaders are automatically notified of progress, and areas requiring attention, making it refreshingly easy to manage at your best.
        <br />
        <br />
        <h3 class="kpis-content-sub-heading">Simplify meeting preparation</h3>
        Use Smart Agendas to bring OKRs into your meetings, centralize notes, and assign action items – all within Teams
    `,
    ],
    [
      'slack',
      `
        <h3 class="kpis-content-sub-heading">Drive alignment with automated slack notifications</h3>
        Send your team direct notifications in Slack from WorkBoard when there is an update to OKRs or an action item request.
        <br />
        <br />
        <h3 class="kpis-content-sub-heading">Capture action items in real time</h3>
        When an actionable idea comes up during a Slack chat, turn it into a Workboard action item with one click.
    `,
    ],
    [
      'cisco_webex',
      `
        <h3 class="kpis-content-sub-heading">Improve visibility with automated Webex notifications </h3>
        Send your team direct notifications in Webex Messaging from WorkBoard when there is an update to OKRs or an action item request.
        <br />
        <br />
        <h3 class="kpis-content-sub-heading">Make meetings purposeful</h3>
        Keep your team aligned on progress to outcomes with smart meeting agendas, accessible within Webex Meetings.
        <br />
        <br />
        <h3 class="kpis-content-sub-heading">Monitor OKR progress without switching tools</h3>
        Bring your OKRs, Heatmap, automated Biz Reviews, and Results Analytics right into your Webex Messaging environment for seamless access to the facts you need every day.
    `,
    ],
    [
      'google',
      `
        <h3 class="kpis-content-sub-heading">Have more productive meetings</h3>
        Sync meetings between Google Calendar and Workboard and create or view WorkBoard meeting agendas with a single click.
        <br />
        <br />
        <h3 class="kpis-content-sub-heading">Never miss another action item</h3>
        Push high priority action items to Google Calendar as a due-date reminder.
        <br />
        <br />
        Note: Only one calendar integration can be enabled at a time.
    `,
    ],
    [
      'outlook',
      `
        <h3 class="kpis-content-sub-heading">Have more productive meetings</h3>
        Sync meetings between Outlook and Workboard and create or view WorkBoard meeting agendas with a single click.
        <br />
        <br />
        <h3 class="kpis-content-sub-heading">Never miss another action item</h3>
        Push high priority action items to Outlook as a due-date reminder.
        <br />
        <br />
        Note: Only one calendar integration can be enabled at a time.
    `,
    ],
    ['workday', getWorkdayLearnMoreContent()],
  ]),
};
